import React, { useMemo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { AppLoader } from '../../components/AppLoader';
import { AppScreen } from '../../components/AppScreen';
import { getAppInfo } from '../../config/appInfo';
import { spacing } from '../../constants/spacing';
import { typography } from '../../constants/typography';
import { useAppColors } from '../../context/PreferencesContext';

export function SplashScreen() {
  const palette = useAppColors();
  const appName = useMemo(() => getAppInfo().appName, []);

  const themed = useMemo(
    () => ({
      title: {
        ...typography.screenTitle,
        color: palette.primary,
        textAlign: 'center' as const,
      },
    }),
    [palette],
  );

  return (
    <AppScreen contentStyle={styles.screen}>
      <View style={styles.content}>
        <Text style={themed.title}>{appName}</Text>
        <AppLoader message="Restoring your secure session" />
      </View>
    </AppScreen>
  );
}

const styles = StyleSheet.create({
  screen: { justifyContent: 'center' },
  content: { alignItems: 'center', gap: spacing.md },
});
